// src/components/AdminOnly.tsx
import useSession from '@hooks/useSession';
import NotFound from '@components/not-found/NotFound';

// Grants access to both Admin (Windvoice.Approver) and Super Admin (Super.admin)
const AdminOnly = ({ children }) => {
  const { isAdmin, isSuperAdmin, loading } = useSession();

  if (loading) {
    return <div>Loading...</div>;
  }
  if (!isAdmin && !isSuperAdmin) {
    return <NotFound />;
  }

  return <>{children}</>;
};

export default AdminOnly;
